import ChatProvider from "./ChatProvider";

export default ChatProvider;
